  /*=========================================================================================
  File Name: mutations.js
  Description: Menus State Module
  ----------------------------------------------------------------------------------------
  Item Name: Fuji Sushi App
  Author: Tan Tran
==========================================================================================*/

export default {
    SET_MENUS_STATE (state, payload) {
        state.menus = payload;
        if (state.menus.length > 0) {
            state.currentMenu = state.menus[0];
          }
    },

    SET_CURRENT_MENU_STATE (state, payload) {
        state.currentMenu = payload;
    }
}